
import React from "react";
import { User } from "@/lib/auth";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { ProfileAvatar } from "@/components/ui/profile-avatar";

interface ProfileInfoProps {
  user: User;
}

export const ProfileInfo: React.FC<ProfileInfoProps> = ({ user }) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center space-x-4">
          <ProfileAvatar 
            avatarUrl={null}
            role={user.role}
            size="xl"
          />
          <div>
            <h2 className="text-xl font-bold">{user.name}</h2>
            <p className="text-sm text-gray-500">{user.role === "admin" ? "Administrateur" : "Ouvrier"}</p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div>
            <label className="text-sm text-gray-500">Pseudo</label>
            <p>{user.nickname || "Non défini"}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Téléphone</label>
            <p>{user.phone || "Non défini"}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Statut</label>
            <p>Connecté</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
